export enum InputValues {
    Text = "Text",
    Dropdown = "Dropdown",
    Checkbox = "Checkbox",
    Button = "Button",
    Navigate = "Navigate",
    Null = "Null"
  }
  
  export enum FunctionInputs {
    OTPEmail = "Fn::otpEmail",
    NewRandomUser = "Fn::newRandomUser"
  }
  
  export interface PageObj {
    pid: number,
    name: string,
    inputs: InputObj[]
  }
  
  export interface InputObj {
    iid: string,
    policyInput: "policy" | "function" | "custom",
    id: string,
    inputType: InputValues | FunctionInputs,
    value: string
  }

  export const compareInputObj = (obj1: InputObj, obj2: InputObj): boolean => {
    if(obj1.id === obj2.id && obj1.inputType === obj2.inputType && obj1.policyInput === obj2.policyInput && obj1.value === obj2.value)
      return true;
    return false;
  }
  
  export interface PageItem {
    input: InputValues,
    id: string,
    restriction?: Array<[string, string]>
  }
  
  export interface strippedInputObj{
    id: string,
    inputType: string,
    value: string
  }